import React from "react";
import brandLogo from "../images/eduhklogo.png";
import libLogo from "../images/eduhkliblogo.png";
import libLogoBw from "../images/eduhkliblogo-bw.png";

export default function Layout({ mType, children }) {
  const getHeading = () => {
    const heading = "Online Application for Library External Membership";
    if (mType) {
      let mTypeText = "";
      switch (mType) {
        case "teacher":
          mTypeText = "School Teacher";
          break;
        case "individual":
          mTypeText = "Individual";
          break;
        case "organisation":
          mTypeText = "Organisation";
          break;
        case "school":
          mTypeText = "School";
          break;
        case "alumni":
        default:
          mTypeText = "Alumni";
          break;
      }
      return `${heading} - ${mTypeText}`;
    }
    return heading;
  };
  return (
    <div className="flex flex-col min-h-screen">
      <header>
        <div className="container mx-auto">
          <div className="py-4 lg:px-0 px-4">
            <a
              href="https://www.eduhk.hk"
              target="_blank"
              rel="noreferrer"
              className="lg:inline-block hidden"
            >
              <img src={brandLogo} alt="EdUHK" className="h-16" />
            </a>
            <a
              href="https://www.lib.eduhk.hk"
              target="_blank"
              rel="noreferrer"
              className="lg:hidden inline-block"
            >
              <img src={libLogo} alt="EdUHK Library" className="h-12" />
            </a>
          </div>
        </div>
        <nav className="nav-wrap">
          <div className="container mx-auto">
            <div className="flex items-center justify-between lg:py-4 lg:px-0 px-4 py-2">
              <h1 className="font-bold lg:text-lg">{getHeading()}</h1>
              <a
                href="https://www.lib.eduhk.hk"
                target="_blank"
                rel="noreferrer"
                className="lg:inline-block hidden"
              >
                <img src={libLogoBw} alt="EdUHK Library" className="h-10" />
              </a>
            </div>
          </div>
        </nav>
      </header>
      <main className="flex-grow">{children}</main>
      <footer className="mt-auto bg-gray-800 text-white lg:py-4 lg:px-0 px-4 py-4">
        <div className="container mx-auto">Copyright © 2023 EdUHK Library</div>
      </footer>
    </div>
  );
}
